import TextInput from "components/common/custom/forms/BootTextField/TextField";
import IconButton from "components/common/IconButton";
import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Plus, Trash } from "react-bootstrap-icons";
import LabTestCodeDescription from "./LabTestCodeDescription";
import { useDispatch, useSelector } from "react-redux";
import {
    addValidationError,
    handleAddLabTest,
    handleDeleteLabTest,
    removeValidationError,
} from "../config/preauthorizationSlice";
import DataTable from "react-data-table-component";
import ConfirmationModal from "components/common/custom/confirmation-modal";
import { useLocation, useSearchParams } from "react-router-dom";
import { GetSearchLabCode } from "../config/preauthorizationApi";

const PreauthLabTest = ({ control, setValue, watch }) => {
    const dispatch = useDispatch();
    const { labTestList, viewPreauthorizationInfo } = useSelector(
        (state) => state.preauthorization
    );


    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [searchParams] = useSearchParams();
    const reuse = searchParams.get("reuse") === "true";
    const edit = searchParams.get("edit") === "true";
    const followUp = searchParams.get("followup") === "true";
    const preauth = searchParams.get("preauth") === "true";


    const preauthLabTest = viewPreauthorizationInfo?.provider_request?.medical_details?.lab;

    console.log({ preauthLabTest })

    useEffect(() => {
        if (
            (reuse || edit || followUp || preauth) &&
            Array.isArray(preauthLabTest) &&
            preauthLabTest?.length > 0
        ) {
            console.log("Test")
            preauthLabTest?.map(item => (
                dispatch(
                    handleAddLabTest({
                        type: "ADDLABTEST",
                        payload: {
                            id: crypto.randomUUID(),
                            lab_test_code: {
                                loinc_code: item?.code,
                                loinc_description: item?.name,
                                loinc_uom: item?.uom || "",
                            },
                            quantity: item?.quantity || "",
                        },
                    })
                )
            ))
        }


    }, [reuse, edit, followUp, preauth, preauthLabTest]);

    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowDeleteModal(true);
    };

    const handleConfirmDelete = () => {
        if (deleteId) {
            dispatch(handleDeleteLabTest({ id: deleteId }));
        }
        setShowDeleteModal(false);
        setDeleteId(null);
    };
    const columns = [
        {
            name: "#",
            sortable: false,
            omit: false,
            cell: (_, index) => (
                <div
                    className="rounded-circle bg-200 d-flex flex-center fs-10 mx-auto"
                    style={{ width: "20px", height: "20px", borderRadius: "50%" }}
                >
                    {index + 1}
                </div>
            ),
            width: "4rem",
        },
        { name: "Lab Code", cell: (row) => row.lab_test_code?.loinc_code },
        {
            name: "Test Name",
            cell: (row) => row.lab_test_code?.loinc_description,
        },
        {
            name: "Lionc UOM",
            cell: (row) => row.lab_test_code?.loinc_uom,
        },
        { name: "Quantity", cell: (row) => row.quantity },
        {
            name: "Action",
            button: true,
            cell: (row) => (
                <IconButton
                    size="sm"
                    variant="danger"
                    onClick={() => handleDeleteClick(row.id)}
                >
                    <Trash size={15} />
                </IconButton>
            ),
        },
    ];

    const handleAddLab = () => {
        if (!watch("lab_test_code")) {
            dispatch(
                addValidationError({
                    field: "Lab Test Code Description",
                    message: "Lab Test Code Description is required",
                })
            );
            return;
        } else {
            dispatch(removeValidationError("Lab Test Code Description"));
        }

        if (!watch("quantity")) {
            dispatch(
                addValidationError({
                    field: "Lab Test Quantity",
                    message: "Lab Test Quantity is required",
                })
            );
            return;
        } else {
            dispatch(removeValidationError("Lab Test Quantity"));
        }

        dispatch(
            handleAddLabTest({
                type: "ADDLABTEST",
                payload: {
                    id: Date.now(), // Add unique ID
                    lab_test_code: watch("lab_test_code"),
                    quantity: watch("quantity"),
                },
            })
        );

        setValue("lab_test_code", null);
        setValue("quantity", "");
    };

    return (
        <div
            style={{ border: "2px solid #d9f8eb" }}
            className="rounded p-3 position-relative mt-4 mb-4"
        >
            <div className="position-absolute top-0 start-45 translate-middle-y px-2">
                <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
                    <span className="fs-10">Lab Test</span>
                </span>
            </div>
            <Row className="align-items-center">
                <Col xs={12} sm={12} xl={6}>
                    <label className="form-label">Lab Test Code</label>
                    <LabTestCodeDescription control={control} setValue={setValue} />
                </Col>
                <Col xs={12} sm={12} xl={6}>
                    <Row>
                        <Col xs={10}>
                            <TextInput
                                name="quantity"
                                label={"Quantity"}
                                size="sm"
                                type="number"
                                required={false}
                                control={control}
                                placeholder="Quantity"
                                rules={{ required: false }}
                            />
                        </Col>
                        <Col xs={2}>
                            <IconButton
                                onClick={handleAddLab}
                                size="sm"
                                variant="success"
                                className="mt-4"
                            >
                                <Plus size={20} />
                            </IconButton>
                        </Col>
                    </Row>
                </Col>
                {labTestList?.length !== 0 && (
                    <Col xs={12} className="mt-3">
                        <DataTable
                            data={labTestList}
                            columns={columns}
                            responsive
                            customStyles={{
                                table: { style: { overflow: "visible" } },
                                rows: { style: { overflow: "visible" } },
                            }}
                        />
                    </Col>
                )}
            </Row>

            <ConfirmationModal
                modal={showDeleteModal}
                setModal={setShowDeleteModal}
                onConfirm={handleConfirmDelete}
                title="Confirm Delete"
                description="Are you sure you want to delete this lab test?"
            />
        </div>
    );
};

export default PreauthLabTest;
